import Vue from 'vue'
import Vuex from 'vuex'
import bot from './modules/bot.store'
import data from './modules/data.store'
import refine from './modules/refine.store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    bot,
    data,
    refine,
  },
  strict: process.env.NODE_ENV !== 'production',
})
